import GenericTemplate from "../Common/GenericTemplate";

// the sub-path and sub-components mapping are in src/Config/routes.js
const DashboardPage = () => {
  const menuItems = [
    { label: "Dashboards", icon: "pi pi-chart-bar", path: "dashboard" },
    { label: "User Guide", icon: "pi pi-file", path: "documents" },
  ];

  return <GenericTemplate menuItems={menuItems} />;
};

export default DashboardPage;